export default (el) => {
    let tabLi = document.querySelectorAll('.tab li'),
        liTriggred = document.querySelector('.tab li.triggered'),
        target = parseInt(el.getAttribute('data-target'));
    liTriggred.querySelector('.tab-content').classList.add('visuallyhidden')
    liTriggred.classList.remove('triggered');
    tabLi[target].classList.add('triggered');
    tabLi[target].querySelector('.tab-content').classList.remove('visuallyhidden');
}